import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Card from 'components/global/Card';

const CardHovers = ({ iconButtonHoverColor = 'var(--forest-60)', linearColors = ['#26cb95', '#0b9669'] }) => css`
	&:hover {
		background: linear-gradient(to bottom, ${linearColors[0]}, ${linearColors[1]});
		background-color: ${linearColors[0]} !important;
		.typography {
			color: var(--white) !important;
		}
		.iconButton {
			background-color: ${iconButtonHoverColor} !important;
			border-color: transparent;
		}
		.card-image {
			transform: scale(1.2);
			bottom: -30%;
			right: -42%;
		}
	}
`;

export const HomeCard = styled(Card)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	min-height: 18rem;
	border: none !important;
	border-radius: var(--medium-border-radius) !important;
	overflow: unset;
	background-color: ${({ backgroundColor }) => backgroundColor || 'var(--blue-10)'} !important;
	cursor: pointer;
	align-items: center;
	position: relative;
	overflow: hidden;
	transition: all 0.3s ease-in-out;
	${CardHovers}
`;

export const HomeCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 60%;
	align-items: center;
	text-align: center;
	z-index: 1;
	button {
		overflow: unset;
	}
	.home-card-title {
		overflow: unset;
	}
	.home-card-button-icon {
		padding: 2.5rem !important;
	}
`;

export const CardBackImage = styled.img`
	position: absolute;
	bottom: -38%;
	right: -45%;
	width: 100%;
	height: 100%;
	object-fit: contain;
	pointer-events: none;
	user-select: none;
	transition:
		all 0.3s ease-in-out,
		transform 0.3s ease-in-out,
		bottom 0.3s ease-in-out;
`;

export const HomeCardContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(21rem, 1fr));
	grid-gap: 1.5rem;
	@container cardContainer (max-width: 65rem) {
		grid-template-columns: 1fr;
	}
`;

export const CardsContainer = styled.div`
	border-radius: var(--small-border-radius);
	background: var(--white);
	border: 1px solid var(--border-color);
	padding: 1.5rem;
	margin-bottom: var(--padding-4);
	container-name: cardContainer;
	container-type: inline-size;
`;
